<div class="accordion-outlet-map">
  <div #mapContainer class="maplibre-container maplibre-accordion-outlet"></div>
</div>
